(() => {
  const C = window.IROVA;
  if (!C) return;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: C.currency || 'USD' });
  const money = cents => fmt.format((Number(cents) || 0) / 100);
  const moneyShort = cents => (Number(cents) % 100 === 0 ? money(cents).replace(/\.00$/, '') : money(cents));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const B = C.bundles;
  const keyById = {};
  Object.keys(B).forEach(k => { keyById[String(B[k].id)] = k; });

  let toastTimer;
  function toast(msg) {
    const t = $('#toast');
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
  }

  // Ad-matched intro: link each ad set to the page with #for-hair, #for-periods or #for-training
  const ANGLES = {
    'for-hair': { kicker: 'For hair shedding', lede: 'Biotin isn’t the only nutrient tied to hair. Studies link low iron stores to increased hair shedding, and Irova is daily iron in a thin strip that melts on your tongue.' },
    'for-periods': { kicker: 'For heavy periods', lede: 'Heavy periods can drain iron stores every month. Irova is one iron strip a day that melts on your tongue, with no pills and no water.' },
    'for-training': { kicker: 'For people who train', lede: 'People who train hard may need 30–70% more iron, per the NIH. Irova is one strip a day that melts on your tongue, with no water needed.' }
  };
  const angle = ANGLES[location.hash.slice(1)];
  if (angle) { $('#kicker-text').textContent = angle.kicker; $('#lede').textContent = angle.lede; }

  // Offer picker
  const form = $('#buy-form');
  const radios = $$('input[name="id"]', form);
  const selectedKey = () => { const r = radios.find(x => x.checked); return r ? r.dataset.key : '2'; };
  function renderPrice() {
    const b = B[selectedKey()];
    $$('[data-price]').forEach(el => { el.textContent = money(b.price); });
    $$('[data-compare]').forEach(el => { el.textContent = b.compare > b.price ? money(b.compare) : ''; el.hidden = !(b.compare > b.price); });
    $$('[data-save]').forEach(el => { const pct = b.compare > b.price ? Math.round((1 - b.price / b.compare) * 100) : 0; el.textContent = pct ? `Save ${pct}%` : ''; el.hidden = !pct; });
    $$('[data-bundle-name]').forEach(el => { el.textContent = b.name; });
    $$('[data-bundle-short]').forEach(el => { el.textContent = b.short; });
    $$('[data-per-day]').forEach(el => { el.textContent = `${money(Math.round(b.price / b.strips))} a day`; });
  }
  radios.forEach(r => r.addEventListener('change', renderPrice));
  $$('[data-pick]').forEach(a => a.addEventListener('click', () => {
    const r = radios.find(x => x.dataset.key === a.dataset.pick);
    if (r && !r.disabled) { r.checked = true; renderPrice(); }
  }));

  $$('[data-strips]').forEach(el => { el.innerHTML = '<i></i>'.repeat(30); });

  // Gallery
  const track = $('#track');
  const slides = $$('.slide', track);
  const dots = $$('#g-dots i');
  const thumbs = $$('.thumb');
  const prev = $('#g-prev');
  const next = $('#g-next');
  let gi = 0;
  function setActive(i) {
    gi = i;
    $('#g-count').textContent = `${i + 1} / ${slides.length}`;
    dots.forEach((d, k) => d.classList.toggle('on', k === i));
    thumbs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i)));
    prev.disabled = i === 0;
    next.disabled = i === slides.length - 1;
  }
  function goTo(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    setActive(i);
  }
  let scrollRaf;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(scrollRaf);
    scrollRaf = requestAnimationFrame(() => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== gi && i >= 0 && i < slides.length) setActive(i);
    });
  }, { passive: true });
  thumbs.forEach(t => t.addEventListener('click', () => goTo(Number(t.dataset.go))));
  prev.addEventListener('click', () => goTo(gi - 1));
  next.addEventListener('click', () => goTo(gi + 1));
  track.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1); }
  });
  window.addEventListener('resize', () => track.scrollTo({ left: gi * track.clientWidth }));

  // Mobile menu
  const menuBtn = $('#menu-btn');
  const mobileNav = $('#mobile-nav');
  function setMenu(open) {
    mobileNav.hidden = !open;
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  menuBtn.addEventListener('click', () => setMenu(mobileNav.hidden));
  $$('#mobile-nav a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  // Cart (Shopify Ajax Cart API)
  const drawer = $('#drawer');
  const scrim = $('#scrim');
  let cart = null;
  let busy = false;
  let lastFocus = null;

  async function api(path, body) {
    const res = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  const thumb = url => url ? url + (url.includes('?') ? '&' : '?') + 'width=140' : C.fallbackImage;

  function renderCart() {
    const items = cart ? cart.items : [];
    const count = cart ? cart.item_count : 0;
    let boxes = 0;
    let oneBoxQty = 0;
    let bogoQty = 0;
    items.forEach(it => {
      const k = keyById[String(it.variant_id)];
      if (k) boxes += B[k].boxes * it.quantity;
      if (k === '1') oneBoxQty += it.quantity;
      if (k === '2') bogoQty += it.quantity;
    });
    const countEl = $('#cart-count');
    countEl.textContent = count;
    countEl.dataset.n = String(count);
    $('#cart-btn').setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`);
    $('#d-subtotal').textContent = money(cart ? cart.total_price : 0);
    $('#checkout').disabled = count === 0;
    const ship = $('#ship');
    const lines = $('#d-lines');
    if (!count) {
      ship.hidden = true;
      lines.innerHTML = '<div class="d-empty"><p>Your cart is empty.</p><button class="btn btn-outline" type="button" data-close>Shop Daily Iron Strips</button></div>';
      return;
    }
    ship.hidden = false;
    const need = Math.max(0, C.freeShipBoxes - boxes);
    ship.innerHTML = `<span>${need === 0 ? '<strong>You’ve unlocked free US shipping.</strong>' : `Add ${need} more box${need === 1 ? '' : 'es'} to unlock <strong>free US shipping</strong>.`}</span>
      <span class="ship-track"><span class="ship-fill" style="width:${Math.min(100, boxes / C.freeShipBoxes * 100)}%"></span></span>
      ${oneBoxQty && B['2'].available ? `<button class="upgrade" type="button" data-upgrade data-q1="${oneBoxQty}" data-q2="${bogoQty}">Get a second box free, same ${moneyShort(B['2'].price)}</button>` : ''}`;
    lines.innerHTML = items.map(it => {
      const k = keyById[String(it.variant_id)];
      const label = k ? B[k].cart : (it.variant_title || '');
      return `<div class="line">
        <img src="${esc(thumb(it.image))}" alt="" width="52" height="70" loading="lazy">
        <div class="line-info"><strong>${esc(it.product_title)}</strong><span>${esc(label)}</span>
          <span class="line-qty"><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Remove one">−</button><output aria-label="Quantity">${it.quantity}</output><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Add one">+</button></span>
        </div>
        <span class="line-price">${money(it.final_line_price)}</span>
      </div>`;
    }).join('');
  }
  async function refresh() {
    try { cart = await api('cart.js'); renderCart(); } catch (e) { /* keep the server-rendered count */ }
  }
  function openCart() {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    drawer.hidden = false;
    document.body.classList.add('cart-open');
    void drawer.offsetWidth;
    scrim.classList.add('open');
    drawer.classList.add('open');
    updateSticky();
    $('#drawer-close').focus();
  }
  function closeCart() {
    scrim.classList.remove('open');
    drawer.classList.remove('open');
    document.body.classList.remove('cart-open');
    setTimeout(() => { scrim.hidden = true; drawer.hidden = true; updateSticky(); }, reduce ? 0 : 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  async function run(task, btn) {
    if (busy) return;
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;
    try { await task(); } catch (e) { toast(e.message); } finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
      if (btn) btn.disabled = false;
    }
  }

  form.addEventListener('submit', e => {
    e.preventDefault();
    const r = radios.find(x => x.checked);
    if (!r) return;
    const btns = $$('[data-atc]');
    run(async () => {
      btns.forEach(b => b.classList.add('loading'));
      try {
        await api('cart/add.js', { items: [{ id: Number(r.value), quantity: 1 }] });
        cart = await api('cart.js');
        renderCart();
        openCart();
      } finally { btns.forEach(b => b.classList.remove('loading')); }
    });
  });
  $('#sticky-atc').addEventListener('click', () => {
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  });
  $('#cart-btn').addEventListener('click', () => { renderCart(); openCart(); refresh(); });
  $('#drawer-close').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) closeCart(); });
  drawer.addEventListener('click', e => {
    const t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.line) {
      run(async () => { cart = await api('cart/change.js', { id: t.dataset.line, quantity: Math.max(0, Number(t.dataset.q)) }); renderCart(); }, t);
    }
    if (t.hasAttribute('data-upgrade')) {
      const q1 = Number(t.dataset.q1);
      const q2 = Number(t.dataset.q2);
      run(async () => {
        const updates = {};
        updates[B['1'].id] = 0;
        updates[B['2'].id] = q2 + q1;
        cart = await api('cart/update.js', { updates });
        renderCart();
        toast('Upgraded to Buy 1, get 1 free');
      }, t);
    }
    if (t.hasAttribute('data-close')) closeCart();
  });
  window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });

  // Sticky add-to-cart: shows whenever the main button is off screen
  const bar = $('#sticky-bar');
  const barBtn = $('#sticky-atc');
  let atcVisible = true;
  function updateSticky() {
    const show = !atcVisible && drawer.hidden;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', String(!show));
    barBtn.tabIndex = show ? 0 : -1;
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { atcVisible = e.isIntersecting; updateSticky(); }).observe($('#atc'));
  }

  // Links that don't exist yet
  $$('[data-soon]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); toast(`${el.dataset.soon} is coming soon`); }));

  // Newsletter: Shopify customer form; check the address before it posts
  const news = $('#news-form');
  if (news) {
    news.addEventListener('submit', e => {
      const input = $('input[type="email"]', news);
      if (!input.value || !input.checkValidity()) {
        e.preventDefault();
        $('#news-msg').textContent = 'Enter an email address like name@example.com.';
        input.focus();
      }
    });
  }

  renderPrice();
  setActive(0);
  refresh();
})();
